import { render } from "./accessibility.vue?vue&type=template&id=76fc0a87&scoped=true&lang=html"
import script from "./accessibility.vue?vue&type=script&lang=js"
export * from "./accessibility.vue?vue&type=script&lang=js"

import "./accessibility.vue?vue&type=style&index=0&id=76fc0a87&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76fc0a87"]])

export default __exports__